import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { Popup, PopupContent, Button } from 'ui';

import s from './ValidationFailedPopup.module.scss';

const cx = cn.bind(s);

const ValidationFailedPopup = ({
  isOpen, onClose, title="Please answer all questions.", className, ...attrs
}) => (
  <Popup isOpen={isOpen} {...attrs} onClose={onClose}>
    <PopupContent title={title} onClose={onClose}>
      <div className={cx('actionRow')}>
        <Button onClick={onClose}>
          OK
        </Button>
      </div>
    </PopupContent>
  </Popup>
);

ValidationFailedPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};
export default ValidationFailedPopup;
